import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: "I've never done yoga before. Can I still join?",
    answer: 'Absolutely! Our classes are designed to accommodate all levels. The instructor provides modifications for beginners and ensures you learn the foundational postures safely at your own pace.'
  }, {
    question: 'What should I wear and bring to class?',
    answer: 'Wear comfortable, breathable clothing that allows you to stretch easily. Bring a water bottle and a small towel. We provide yoga mats, but you are welcome to bring your own for personal hygiene.'
  }, {
    question: 'Do I need to book classes in advance?',
    answer: 'Yes, we recommend booking your slot in advance as we keep our batch sizes small (max 15 students) to ensure personalized attention for everyone.'
  }, {
    question: 'Can yoga help with my back pain/injury?',
    answer: 'Yoga can be highly therapeutic for back pain. However, please inform the instructor about any specific injuries or medical conditions before the class begins so they can suggest appropriate modifications.'
  }, {
    question: 'What is the difference between Hatha and Power Yoga?',
    answer: 'Hatha yoga focuses on holding postures and breath control at a slower pace, great for alignment and relaxation. Power yoga is a faster, more dynamic flow that builds heat, strength, and cardiovascular endurance.'
  }, {
    question: 'Can I switch between morning and evening batches?',
    answer: 'Yes, our monthly and quarterly members have the flexibility to attend either morning or evening batches, subject to slot availability. Just let us know in advance.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 bg-white" data-id="element-157">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="text-center mb-16" data-id="element-159">
          <FadeIn data-id="element-160">
            <span className="text-yoga-primary font-bold uppercase tracking-wider text-sm block mb-2" data-id="element-161">
              Got Questions?
            </span>
            <h2 className="text-4xl font-bold text-yoga-dark mb-4" data-id="element-162">
              Frequently Asked Questions
            </h2>
          </FadeIn>
        </div>

        <div className="space-y-4" data-id="element-163">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 50} data-id="element-164">
              <div className={`border rounded-2xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-yoga-primary bg-yoga-lightest/30' : 'border-gray-200 bg-white hover:border-yoga-primary/50'}`} data-id="element-165">
                <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={() => toggleAccordion(index)} aria-expanded={openIndex === index} data-id="element-166">
                  <span className={`font-bold text-lg pr-8 ${openIndex === index ? 'text-yoga-primary' : 'text-yoga-dark'}`} data-id="element-167">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'transform rotate-180 text-yoga-primary' : 'text-gray-400'}`} data-id="element-168" />
                </button>

                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-169">
                  <div className="px-6 pb-5 text-yoga-muted leading-relaxed border-t border-gray-100 pt-4" data-id="element-170">
                    {faq.answer}
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <div className="mt-12 text-center" data-id="element-171">
          <FadeIn delay={300} data-id="element-172">
            <p className="text-yoga-muted" data-id="element-173">
              Still have questions?{' '}
              <a href="#contact" className="text-yoga-primary font-bold hover:underline" data-id="element-174">
                Contact us directly
              </a>
              .
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}